import apiClient from '@/services/axios'

export async function post() {
  var response = await apiClient({
    method: 'post',
    url: '/Payrates/ExportPlandayPayrateChanges',
    responseType: 'blob'
  })

  if (response) {
    return response.data
  }

  throw new Error('Unable to export payrate changes.')
}